<template>
  <img class="banner" :src="img" />
</template>

<script>
export default {
  name: "banner",
  props: {
    img: String
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.banner {
  width: 100%;
  height: 600px;
  object-fit: cover;
}
</style>
